import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { Select, MenuItem } from "@mui/material";
import { callAPI } from "../../../axios";
import { setChainIdAction } from "../../../store/actions/GetChainId/SetChainIdActions";
import { useDispatch, useSelector } from "react-redux";
import {
  getChainIdLS,
  setChainIdLS,
  isAutoModeViewerRoleCode,
  formatHotelDisplayName,
  HOTEL_MASTER_UPDATED_LS_KEY,
} from "../../../utils/utils";
import { setViewTypeAction } from "../../../store/actions/GetViewType/SetViewTypeActions";
import { Autocomplete, TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

const isSelectedHotelDataChanged = (existingHotel, updatedHotel) => {
  if (!existingHotel || !updatedHotel) return true;
  return (
    existingHotel.code !== updatedHotel.code ||
    existingHotel.name !== updatedHotel.name ||
    existingHotel.viewType !== updatedHotel.viewType ||
    existingHotel.enterpriseChainId !== updatedHotel.enterpriseChainId ||
    existingHotel.testHotel !== updatedHotel.testHotel ||
    existingHotel.demoHotel !== updatedHotel.demoHotel
  );
};

const getHotelBrandSubtitle = (option) => {
  if (!option) return "";
  return option.viewType === "custom"
    ? "TP-HMS"
    : `${(option.brandDisplayName ?? "").toString()}`;
};

const SelectHotel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation()
  const [hotelList, setHotelList] = useState([]);
  const [hotelListFlag, setHotelListFlag] = useState(false);
  const [lastSelectedHotel, setLastSelectedHotel] = useState(null);
  // const [chainId, setChainId] = useState("");
  const { control, watch, setValue } = useForm({
    defaultValues: {
      chainId: '',
    },
  });
  const selectedChainId = watch('chainId');
  const { hotelUpdateFlag } = useSelector((state) => state.updateMasterHotelReducer)
  const { chainId: reduxChainId } = useSelector((state) => state.chainIdReducer);
  const disableHotel = ((props?.userRoleCode === "ROLE_SUPER_ADMIN" && location?.pathname === "/hms/ConfigurationNewHotel") || location?.pathname === "/hms/DefaultConfig" || location?.pathname === "/hms/PartnerConfiguration" ||
    location?.pathname === "/hms/RoomTypeConfiguration" || location?.pathname === "/hms/UtilityServiceConfiguration" || location?.pathname === "/hms/fetchcdsndetails" ||
    location?.pathname === "/hms/userList" || location?.pathname === "/hms/createEditUser" || location?.pathname === "/hms/roles" || location?.pathname === "/hms/rolesPermissions" ||
    location?.pathname === "/hms/userPrivilege" || location?.pathname === "/hms/SatelliteChannelMapping" || location?.pathname === "/hms/editUser" || location?.pathname === "/hms/pending-approvals" ||
    location?.pathname === "/hms/edit-role" || location?.pathname === "/hms/create-role" || location?.pathname === "/hms/myAccount" || location?.pathname === "/hms/changePassword" ||
    location?.pathname === "/hms/APKProviderConfiguration" || location?.pathname === "/hms/SoftwareStackDetails" || location?.pathname === "/hms/Dashboard/Hotels_Dashboard" || location?.pathname === "/hms/WhitelistDomain" ||
    location.pathname === "/hms/Dashboard/Automode_Dashboard" || location.pathname === "/hms/Dashboard/AssetManagement_Dashboard" || location.pathname === "/hms/thirdPartyHotelConfiguration" ||
    location.pathname === "/hms/Dashboard/Test_Demo_Hotels_Dashboard"
  )
  const syncSelectedHotelToRedux = useCallback((selectedChainId, selectedMasterHotel, forceUpdate = false) => {
    const existingHotel = reduxChainId?.navSelectedhotelName?.[0];
    const updatedHotel = selectedMasterHotel[0];

    if (!forceUpdate && !isSelectedHotelDataChanged(existingHotel, updatedHotel)) {
      return;
    }

    dispatch(setChainIdAction({
      selectedChainId,
      navSelectedhotelName: selectedMasterHotel,
    }));
  }, [dispatch, reduxChainId]);

  const applyMasterHotelsResponse = useCallback((response, { chainIdToSelect, forceReduxSync = false } = {}) => {
    const data = response?.data ?? [];
    setHotelList(data);
    setHotelListFlag(true);

    const currentChainId = chainIdToSelect ?? getChainIdLS();
    const selectedMasterHotel = data.filter((item) => item.code === currentChainId);

    if (selectedMasterHotel.length) {
      setValue('chainId', currentChainId);
      setChainIdLS(currentChainId);
      syncSelectedHotelToRedux(currentChainId, selectedMasterHotel, forceReduxSync);
      dispatch(setViewTypeAction(selectedMasterHotel[0]?.viewType));
      return selectedMasterHotel[0];
    }

    if (data.length) {
      const fallbackChainId = data[0].code;
      setValue('chainId', fallbackChainId);
      setChainIdLS(fallbackChainId);
      syncSelectedHotelToRedux(fallbackChainId, [data[0]], forceReduxSync);
      dispatch(setViewTypeAction(data[0].viewType));
      return data[0];
    }

    return null;
  }, [dispatch, setValue, syncSelectedHotelToRedux]);

  const fetchMasterHotels = useCallback((options = {}) => {
    return callAPI(`master?type=HOTELS`, "GET")
      .then((response) => applyMasterHotelsResponse(response, options))
      .catch((error) => {
        console.warn(error);
        return null;
      });
  }, [applyMasterHotelsResponse]);

  const handleHotelSelectionNavigation = useCallback((selectedHotel) => {
    if (!selectedHotel) {
      return;
    }

    if (
      selectedHotel.viewType === "hotelApp" &&
      props?.userRoleCode !== "ROLE_SUPER_ADMIN" &&
      !isAutoModeViewerRoleCode(props?.userRoleCode)
    ) {
      if (location?.pathname !== "/hms/ConfigurationMasterApk") {
        navigate("/hms/HotelOnboardingWizard");
      }
    } else if (
      selectedHotel.viewType === "custom" &&
      location?.pathname === "/hms/ConfigurationMasterApk"
    ) {
      navigate("/hms/ConfigurationNewHotel");
    }
  }, [location?.pathname, navigate, props?.userRoleCode]);

  const fetchMasterHotelsRef = useRef(fetchMasterHotels);
  fetchMasterHotelsRef.current = fetchMasterHotels;

  useEffect(() => {
    fetchMasterHotelsRef.current();
  }, [hotelUpdateFlag]);

  useEffect(() => {
    const handleCrossTabHotelUpdate = (event) => {
      if (event.key === HOTEL_MASTER_UPDATED_LS_KEY) {
        fetchMasterHotelsRef.current();
      }
    };

    window.addEventListener("storage", handleCrossTabHotelUpdate);
    return () => window.removeEventListener("storage", handleCrossTabHotelUpdate);
  }, []);

  const initialRender = useRef(true);
  /** Only redirect after an explicit hotel pick — not when chainId is synced from API/LS on load or URL nav. */
  const userInitiatedHotelChangeRef = useRef(false);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false
      return;
    }

    if (!selectedChainId) {
      return;
    }

    setChainIdLS(selectedChainId);
    const shouldRunHotelNav = userInitiatedHotelChangeRef.current;
    if (shouldRunHotelNav) {
      userInitiatedHotelChangeRef.current = false;
    }

    fetchMasterHotelsRef.current({ chainIdToSelect: selectedChainId, forceReduxSync: true })
      .then((selectedHotel) => {
        if (shouldRunHotelNav) {
          handleHotelSelectionNavigation(selectedHotel);
        }
      });
  }, [selectedChainId]);

  useEffect(() => {
    if (hotelListFlag) {
      let hotelListItems = JSON.parse(
        JSON.stringify(hotelList)
      );
      let viewType = hotelListItems.filter((item) => item?.code === selectedChainId);
      dispatch(setChainIdAction({ selectedChainId, navSelectedhotelName: viewType }));
      dispatch(setViewTypeAction(viewType?.[0]?.viewType));
    }
  }, [hotelListFlag])

  return (
    <Controller
      name="chainId"
      control={control}
      render={({ field }) => (
        <Autocomplete
          options={hotelList}
          getOptionLabel={formatHotelDisplayName}
          isOptionEqualToValue={(option, value) => option?.code === value?.code}
          value={
            hotelList.find((hotel) => hotel.code === field.value) || null
          }
          onChange={(_, selectedHotel) => {
            const hotelCode = selectedHotel?.code || '';
            if (selectedHotel && hotelCode !== field.value) {
              userInitiatedHotelChangeRef.current = true;
            }
            field.onChange(hotelCode);
            if (selectedHotel) {
              setLastSelectedHotel(selectedHotel); // update last valid
            }
          }}
          onBlur={() => {
            const selectedHotel = hotelList.find(hotel => hotel.code === field.value);
            if (!selectedHotel && lastSelectedHotel) {
              setValue('chainId', lastSelectedHotel.code); // restore last valid
            }else{
              setValue('chainId', getChainIdLS());
            }
          }}
          renderOption={(props, option) => {
            const hotelLabel = formatHotelDisplayName(option);
            const subtitle = getHotelBrandSubtitle(option);
            return (
              <li {...props} key={option.code}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                      fontWeight: "normal",
                      fontSize: "14px",
                    }}
                  >
                    {hotelLabel}
                  </div>
                  <div
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      whiteSpace: "normal",
                      overflowWrap: "anywhere",
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "2px",
                    }}
                  >
                    {`(${subtitle})`}
                  </div>
                </div>
              </li>
            );
          }}
          componentsProps={{
            paper: {
              sx: { maxWidth: 360 },
            },
          }}
          disabled={disableHotel}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              className="select-project"
            />
          )}
        />

      )}
    />
  );
};

export default SelectHotel;
